<p-dialog
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [style]="{ width: '42rem', maxHeight: '85vh' }"
  styleClass="bn-household-member-profile-dialog"
  data-testid="household-member-profile-dialog">
  <div class="bn-hm-profile-header">
    <div class="min-w-0">
      <h2 class="bn-hm-profile-title" data-testid="household-member-profile-title">{{ title() }}</h2>
      <p class="bn-hm-profile-subtitle">Household member profile</p>
    </div>
    <button
      type="button"
      class="bn-hm-profile-close"
      data-testid="household-member-profile-close"
      aria-label="Close"
      (click)="close()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="bn-hm-profile-body" data-testid="household-member-profile-body">
    @if (memberGuid(); as guid) {
      <bn-client-profile
        [guid]="guid"
        profileKind="householdMember" />
    }
  </div>
</p-dialog>
